import CreateActivityButton from './CreateActivityButton';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
function ErrorButton({
  interactionName,
  objectId,
  objectTypeId,
  taskId,
  buttonSize,
  isOverflow = false
}) {
  return /*#__PURE__*/_jsx(CreateActivityButton, {
    interactionName: interactionName || '',
    objectId: objectId,
    objectTypeId: objectTypeId,
    taskId: taskId,
    buttonSize: buttonSize,
    disabled: true,
    isOverflow: isOverflow,
    isError: true
  });
}
export default ErrorButton;